jQuery(function($) {

    $('.key-steps a.close-btn').on('click', function(e) {
        e.preventDefault();

        $(this).parents('.key-steps__item').removeClass('is-active');
        $('html').removeClass('overflow-hidden');
    });

    $('.key-steps a.trigger-btn').on('click', function(e) {
        e.preventDefault();

        $(this).parents('.key-steps__item').addClass('is-active')
        $('html').addClass('overflow-hidden');
    });

    $(document).mouseup(function(e) {
        var container = $(".key-steps__item.is-active");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('is-active');
            $('html').removeClass('overflow-hidden');
        }
    });

    function onWindowResize() {

        let windowWidth = window.innerWidth;

        if(windowWidth <= 1500) {
            $('.key-steps').addClass('is-mobile');
        } else {
            $('.key-steps').removeClass('is-mobile');
        }
    }

    $(window).on('resize', onWindowResize);
    onWindowResize();

    const ratio = .9;
    const options = {
        'root': null,
        'rootMargin': '0px 0px -100px 0px',
        'threshold': ratio
    };

    const handleIntersect = function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.intersectionRatio > ratio) {
                let entry_index = entry.target.getAttribute('data-index');
                if( entry_index == 0 ) {

                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);

                } else {

                    let need_class = true;
                    for(let i = 0; i < entry_index; i++) {
                        if(!document.querySelector(`[data-index="${i}"]`).classList.contains('active')) {
                            need_class = false;
                            break;
                        }
                    }

                    if(need_class) {
                        entry.target.classList.add('active');
                        observer.unobserve(entry.target);

                        if(entry_index == 3 ) {
                            setTimeout(function(){
                                document.querySelector('.key-steps__item[data-index="4"]').classList.add('active');
                                observer.unobserve(document.querySelector('.key-steps__item[data-index="4"]'));
                            }, 2000);

                            setTimeout(function(){
                                document.querySelector('.key-steps__item[data-index="5"]').classList.add('active');
                                observer.unobserve(document.querySelector('.key-steps__item[data-index="5"]'));
                            }, 4000);
                        }
                    }

                }
            }
        });
    }

    window.addEventListener('DOMContentLoaded', function () {
        const observer = new IntersectionObserver(handleIntersect, options);
        document.querySelectorAll('.key-steps__item').forEach(function (r) {
            observer.observe(r);
        });
    });

});